// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__q9bcg","error":"styles_error__XgaRk","success":"styles_success__ZJwNN"};